/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Week_SyncingInputs */



/**
* | output |
* | --- |
* | "We are reading your calendar — one moment." |
*
* @param {Onboarding_Week_SyncingInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const onboarding_week_syncing = /** @type {((inputs?: Onboarding_Week_SyncingInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Week_SyncingInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("We lezen je agenda — een moment.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nous lisons votre agenda — un instant.")
	return /** @type {LocalizedString} */ ("We are reading your calendar — one moment.")
});